import DOMPurify from "dompurify";
import { SANITIZE_CONFIG, SPACED_UNWRAP_TAGS } from "../constants";

const Purifier = DOMPurify();

Purifier.addHook("uponSanitizeElement", (node) => {
  if (!SPACED_UNWRAP_TAGS.includes(node.nodeName)) return;
  const doc = node.ownerDocument;
  if (!doc) return;
  node.insertBefore(doc.createTextNode(" "), node.firstChild);
  node.appendChild(doc.createTextNode(" "));
});

const sanitize = (input: string | Element) => {
  const html = typeof input === "string" ? input : input.outerHTML;
  return Purifier.sanitize(html, { ...SANITIZE_CONFIG, RETURN_DOM: true }) as HTMLElement;
};

export { sanitize };
